import React from 'react';
import { Modal } from 'antd';
import { MembershipProduct, UserInfo } from '@/types/membership';

interface PurchaseConfirmModalProps {
  isVisible: boolean;
  selectedProduct: MembershipProduct | null;
  userInfo?: UserInfo;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function PurchaseConfirmModal({
  isVisible,
  selectedProduct,
  userInfo,
  onConfirm,
  onCancel
}: PurchaseConfirmModalProps) {
  return (
    <Modal
      title="确认购买"
      open={isVisible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="确认购买"
      cancelText="取消"
    >
      {selectedProduct && (
        <div className="text-center">
          <p className="text-lg mb-4">您确定要购买 {selectedProduct.name} 吗？</p>
          <p className="text-gray-600">价格：¥{selectedProduct.price}</p>
          <p className="text-gray-600">当前余额：¥{userInfo?.balance || 0}</p>
          {userInfo && userInfo.balance < selectedProduct.price && (
            <p className="text-red-500 mt-2">余额不足，请先充值</p>
          )}
        </div>
      )}
    </Modal>
  );
}